import { render } from "./user-management.vue?vue&type=template&id=18cd9155&scoped=true&ts=true&lang=pug"
import script from "./user-management.vue?vue&type=script&lang=ts"
export * from "./user-management.vue?vue&type=script&lang=ts"

import "./user-management.vue?vue&type=style&index=0&id=18cd9155&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18cd9155"]])

export default __exports__